interface stateType {
  mainHeight: number
  mainLoaded: boolean
}

export default {
  namespaced: true,
  state: () => ({
    mainHeight: 0,
    mainLoaded: false
  }),
  mutations: {
    setMainHeight(state: stateType, height: number) {
      state.mainHeight = height
    },
    setMainLoaded(state: stateType, loaded: boolean) {
      state.mainLoaded = loaded
    }
  },
  actions: {},
  getters: {}
}
